import React from "react";

export default function DropdownSelectionTick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M10.5 0.5L4.2487 6.5L0.5 2.9"
        stroke="#148DFD"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
